import { createContext, useContext, useState, type ReactNode } from "react";
import type { HealthRecord } from "@/shared/types";

interface PatientDataContextValue {
  records: HealthRecord[];
  addRecords: (records: HealthRecord[]) => void;
  selectedRecord: HealthRecord | null;
  setSelectedRecord: (record: HealthRecord | null) => void;
}

const PatientDataContext = createContext<PatientDataContextValue | null>(null);

export function PatientDataProvider({ children }: { children: ReactNode }) {
  const [records, setRecords] = useState<HealthRecord[]>([]);
  const [selectedRecord, setSelectedRecord] = useState<HealthRecord | null>(null);

  const addRecords = (newRecords: HealthRecord[]) => {
    setRecords((prev) => [...prev, ...newRecords]);
  };

  return (
    <PatientDataContext.Provider
      value={{ records, addRecords, selectedRecord, setSelectedRecord }}
    >
      {children}
    </PatientDataContext.Provider>
  );
}

export function usePatientData() {
  const ctx = useContext(PatientDataContext);
  if (!ctx) throw new Error("usePatientData must be used within PatientDataProvider");
  return ctx;
}
